import { render, staticRenderFns } from "./qualifications-tabel.vue?vue&type=template&id=1f011791"
import script from "./qualifications-tabel.vue?vue&type=script&lang=ts"
export * from "./qualifications-tabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports